import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'  // 引入全局样式
import ApiPlugin from './common/plugins/api'
import MessagePlugin from './components/Message'

// 轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

// 使用插件
Vue.use(ElementUI)
Vue.use(ApiPlugin)
Vue.use(MessagePlugin)
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
